import { render, staticRenderFns } from "./ReSearchScndObjSmall.vue?vue&type=template&id=4da61f62&scoped=true"
import script from "./ReSearchScndObjSmall.vue?vue&type=script&lang=js"
export * from "./ReSearchScndObjSmall.vue?vue&type=script&lang=js"
import style0 from "./ReSearchScndObjSmall.vue?vue&type=style&index=0&id=4da61f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da61f62",
  null
  
)

export default component.exports